<template lang="pug">
#gestao-contratos-originacao-subempresa
    BaseHeader(
        :titulo='$t("mensagens.subEmpresaGestao.labels.subEmpresaGestao")',
        :exibeBotao='false'
    )

    .view-container.margen-bottom-pages
        .bloco-infor-dados
            SkeletonBlocoInformacao(:carregando='skeletonBlocoInforDados')
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.contratos")',
                    :numero='totalContratosOriginacao.totalContratosOriginacao'
                )
                    template(slot='icone')
                        i.mdi.mdi-swap-horizontal-bold

            SkeletonBlocoInformacao(:carregando='skeletonBlocoInforDados')
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.territorios")',
                    :numero='totalContratosOriginacao.totalImoveis'
                )
                    template(slot='icone')
                        i.mdi.mdi-home-variant-outline

            SkeletonBlocoInformacao(:carregando='skeletonBlocoInforDados')
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.volumeContratado")',
                    :numero='totalContratosOriginacao.totalVolumeContratado',
                    sigla='t'
                )
                    template(slot='icone')
                        i.mdi.mdi-chart-bar

            SkeletonBlocoInformacao(:carregando='skeletonBlocoInforDados')
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.volumeRastreado")',
                    :numero='totalContratosOriginacao.totalVolumeEntregue',
                    sigla='t'
                )
                    template(slot='icone')
                        i.mdi.mdi-chart-bar

            SkeletonBlocoInformacao(:carregando='skeletonBlocoInforDados')
                BlocoInformacao(
                    :titulo='$t("mensagens.subEmpresaGestao.labels.volumeAndamento")',
                    :numero='totalContratosOriginacao.totalVolumeAndamento',
                    sigla='t'
                )
                    template(slot='icone')
                        i.mdi.mdi-chart-bar

        .bloco-pesquisa-filtros
            PesquisaAvancada(@emitFiltros='adicionarFiltros')
            .bloco-pesquisa-filtros__acoes
                UploadRecebimentosLoteAcao(@atualizar='buscarContratosSucursales')
        .bloco-novos-contratos-tabela
            Tabela(
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela'
            )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoInformacao from '@/components/contratosOriginacao/SubEmpresaBlocoInformacao.vue';
import SkeletonBlocoInformacao from '@/components/contratosOriginacao/SubEmpresaBlocoInformacaoSkeleton.vue';
import Tabela from '@/components/sucursales/TabelaContratos.vue';
import PesquisaAvancada from '@/components/sucursales/PesquisaAvancada.vue';
import UploadRecebimentosLoteAcao from '@/components/contratosOriginacao/UploadRecebimentosLoteAcao.vue';
import SucursaleService from '@/services/SucursaleService';
import { mapGetters } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'RastreabilidadeSucursales',
    components: {
        BaseHeader,
        BlocoInformacao,
        SkeletonBlocoInformacao,
        Tabela,
        PesquisaAvancada,
        UploadRecebimentosLoteAcao
    },
    data() {
        return {
            AmbientesEmpresas,
            totalContratosOriginacao: {
                totalContratosOriginacao: null,
                totalImoveis: null,
                totalVolumeContratado: null,
                totalVolumeEntregue: null,
                totalNovosContratos: null
            },
            contratosTabela: [],
            paginacao: {},
            params: {
                page: 0,
                size: 10,
                sort: 'dataAtualizacao',
                por: 'desc'
            },
            filtro: {
                pesquisaFiltro: '',
                idsSafra: [],
                codigosStatus: [],
                dataContratoInicio: '',
                dataContratoFim: '',
                idSucursal: ''
            },
            skeletonBlocoInforDados: true,
            CheckListagemContratoErro: false,
            carregandoTabela: false,
            statusEmpresa: [],
            isRoleFeatureRastreabilidadeEmpresa: false
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    mounted() {
        this.buscarTotalizadores();
        this.buscarContratosSucursales();
    },
    methods: {
        async buscarTotalizadores() {
            try {
                this.skeletonBlocoInforDados = true;
                const { data } = await SucursaleService.totalizadores(
                    this.filtro
                );

                this.totalContratosOriginacao = { ...data };
                this.skeletonBlocoInforDados = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.labels.naoFoiPossivelBuscar'
                    )
                });
                this.skeletonBlocoInforDados = false;
            }
        },
        async buscarContratosSucursales() {
            this.carregandoTabela = true;
            try {
                const { data } = await SucursaleService.listagemContratos(
                    this.filtro,
                    this.params
                );

                this.contratosTabela = data.itens;
                this.paginacao = data.paginacao;
                this.isRoleFeatureRastreabilidadeEmpresa =
                    data.roleFeatureRastreabilidadeEmpresa;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.labels.naoFoiPossivelBuscarDados'
                    )
                });
            }

            this.carregandoTabela = false;
        },
        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.params.page = novaPagina;
            this.buscarContratosSucursales();
        },
        ordenarTabela(column) {
            this.params.sort = column.prop;
            this.params.por = column.order;
            this.buscarContratosSucursales();
        },
        adicionarFiltros(filtro) {
            this.filtro = {
                dataCadastroInicio: filtro.dataCadastroInicio,
                dataCadastroFim: filtro.dataCadastroFim,
                idsSafra: filtro.safras,
                codigosStatus: filtro.status,
                pesquisaFiltro: filtro.pesquisa,
                idLocalidadeNivelUm: filtro.idLocalidadeNivelUm,
                idSucursal: filtro.idSucursal
            };
            this.params.page = 0;
            this.buscarContratosSucursales();
            this.buscarTotalizadores();
        }
    }
};
</script>

<style lang="scss">
#gestao-contratos-originacao-subempresa {
    .bloco-infor-dados {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 8px;
        width: 100%;
        flex-wrap: wrap;

        &--eudr {
            grid-template-columns: repeat(3, 1fr);
        }
        &--eudr {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
        }
    }
    .bloco-novos-contratos-preenchimento,
    .bloco-infor-dados,
    .bloco-pesquisa-filtros,
    .bloco-novos-contratos-tabela {
        margin-top: 20px;
    }
    .bloco-pesquisa-filtros {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 8px;
        align-items: start;

        &__acoes {
            display: flex;
            align-items: center;
            gap: 4px;
            height: 43px;
            margin-top: 20px;
            white-space: nowrap;
        }

    }
    .total-contratos {
        font-size: 19px;
        margin-right: 6px;
    }
}
.alertas-contratos-interno {
    display: flex;
    align-items: center;

    span {
        font-size: 22px;
        color: #3b3b3b;
        margin-right: 10px;
    }
    .link {
        color: #3fb1f2;
        margin-left: 6px;
        cursor: pointer;
        text-decoration: underline;
    }
    .link:hover {
        color: #ddac44;
    }
}
.alertas-enter-active,
.alertas-leave-active {
    transition: opacity 0.5s;
}
.alertas-enter,
.alertas-leave-to {
    opacity: 0;
}
</style>
